import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Resolve an image URL for browser rendering.
 *
 * Historically some image URLs were stored as absolute strings that included
 * the preview host at the time of upload (e.g. https://booking-hub-920.preview…).
 * When the preview URL rotates (after forking / restarts) those old absolute
 * hosts die and every `<img src>` breaks silently. We normalise all display
 * paths through this helper: if the stored value starts with `/api/uploads/`
 * (path-relative — the format the backend returns from `/api/admin/upload`),
 * we prepend the current backend origin. External URLs and data-URIs pass through.
 */
export const resolveImg = (v) => {
  if (!v) return '';
  if (typeof v !== 'string') return v;
  if (v.startsWith('/api/')) return `${BACKEND_URL}${v}`;
  // Handle legacy absolute URLs that point to an old preview host by stripping
  // the host and re-anchoring to the current backend origin. Any URL matching
  // .../api/uploads/<file> is rewritten to the current backend.
  const m = v.match(/https?:\/\/[^/]+(\/api\/uploads\/[^?#]+)/);
  if (m) return `${BACKEND_URL}${m[1]}`;
  return v;
};

export const api = axios.create({ baseURL: API, headers: { 'Content-Type': 'application/json' } });

export const submitEnquiry = (payload) => api.post('/enquiries', payload).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post('/subscribe', { email }).then((r) => r.data);

// Blogs
export const fetchBlogs = () => api.get('/blogs').then((r) => r.data);
export const fetchBlog = (slug) => api.get(`/blogs/${slug}`).then((r) => r.data);
export const adminAuthHeader = () => ({ 'X-Admin-Token': typeof window !== 'undefined' ? (localStorage.getItem('travelsera_admin_token') || '') : '' });
export const adminListBlogs = () => api.get('/admin/blogs', { headers: adminAuthHeader() }).then((r) => r.data);
export const adminCreateBlog = (payload) => api.post('/admin/blogs', payload, { headers: adminAuthHeader() }).then((r) => r.data);
export const adminUpdateBlog = (slug, payload) => api.put(`/admin/blogs/${slug}`, payload, { headers: adminAuthHeader() }).then((r) => r.data);
export const adminDeleteBlog = (slug) => api.delete(`/admin/blogs/${slug}`, { headers: adminAuthHeader() }).then((r) => r.data);
